import 'react-tabulator/lib/styles.css'; 
import "react-tabulator/lib/css/bootstrap/tabulator_bootstrap4.min.css";
import '../../resources/css/maintenance/ModelList.scss';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { ReactTabulator, reactFormatter } from 'react-tabulator';
import { Row } from 'react-bootstrap';
import ReactExport from "react-data-export";
import moment from 'moment';
import { enableModal, toggleSteamClean, toggleAirQuality, forwarModelDetail, getModelDetail, removeModel, 
  DELETE_MODEL_SUCCESS, DELETE_MODEL_FAIL, forwardModelList, initModelsData } from '../../actions/maintenance/index';
import FilterSearch from '../common/FilterSearch';
import ListSettingBtn from '../common/ListSettingBtn';
import CommonListFooter from '../common/CommonListFooter';
import { updateMaxPageNumber, keepTableInfoToSession, getTableInfoFromSession, reloadTable, groupMenuTitleFormatter, commonListFooter } from '../common/access-list';
import Loading from '../../components/common/Loading';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

let viewRow, editRow, deleteRow, toggleSteamCleanRow, toggleAirQualityRow, toggleEnableRow;

const SteamCleanColumn = (props) => {
  const cellData = props.cell._cell.row.data;
  let classIcon;

  if (cellData.steamClean === 1) {
    classIcon = 'icon-btn-checkbox-p';
  } else {
    classIcon = 'icon-btn-checkbox-n';
  }
  return (
    <span className='area-enable-icon' onClick={() => toggleSteamCleanRow(props.cell, cellData.steamClean)}>
      <span className={classIcon} />
    </span>      
  );
};

const AirQualityColumn = (props) => {
  const cellData = props.cell._cell.row.data;
  let classIcon;

  if (cellData.airQuality === 1) {
    classIcon = 'icon-btn-checkbox-p';
  } else {
    classIcon = 'icon-btn-checkbox-n';
  }
  return (
    <span className='area-enable-icon' onClick={() => toggleAirQualityRow(props.cell, cellData.airQuality)}>
      <span className={classIcon} />
    </span>      
  );
};

const EnableColumn = (props) => {
  const cellData = props.cell._cell.row.data;
  let classIcon;

  if (cellData.Enabled === 1) {
    classIcon = 'icon-btn-checkbox-p';
  } else {
    classIcon = 'icon-btn-checkbox-n';
  }

  return (
    <span className='area-enable-icon' onClick={() => toggleEnableRow(props.cell, cellData.Enabled)}>
      <span className={classIcon} />
    </span>      
  );
};

const GroupBtnsMenu = (props) => {
  // const cellData = props.cell._cell.row.data;
  return (
      <div className='group-buttons-menu'>
          <span className='operation-button-area'>
            <span className='btn-area'><span className='icon-btn-info' onClick={() => viewRow(props)}/></span>
            <span className='btn-area'><span className='icon-btn-edit2' onClick={() => editRow(props)}/></span>
            <span className='btn-area'><span className='icon-btn-remove' onClick={() => deleteRow(props)}/></span>
          </span>
          <span className='more-button-area'>
            <span className='btn-area'><span className='icon-btn-more-dark'/></span>
          </span>
      </div>
  );
};

class ModelList extends Component {
  tableId = 'modelList'
  refFilterSearch = null
  refListCommonFooter = null
  // set this state for re-fresh sub component
  state = {
    test: null,
    refTable: null,
    isInitComplete: false,
    filterColumns: [
      { title: "Model Name", field: "modelName", visible: false }      
    ],
    /**
     *  quickSearchFilter is array
     *  title is menu tile
     *  filters is menu items
     *  filter: name and field to make the id, and checked is default checked or not.
     *          value and field will into filter for table
     */
    quickSearchFilter : [{
      title: 'Status',
      filter: [
        { name:'enable', title: 'Enable', field: 'Enabled', type:"like", value: '1', checked: true },
        { name:'disable', title: 'Disable', field: 'Enabled', type:"like", value: '0', checked: true }, 
      ]
    }],

    /**
     *  visibleColumnsConfig is array
     *  title is menu tile
     *  columns is all changed visible columns for table list to display
     */
    visibleColumnsConfig : {
      title: 'Visible Columns',
      columns: [
        { name:'modelName', title: "Model Number", field: "modelName" },
        { name:'maxFanSpeed', title: "Max. Fan Speed", field: "maxFanSpeed" },
        { name:'maxLightLevel', title: "Max. Lighting Level", field: "maxLightLevel" },
        // { name:'maxGreasefilterTimer', title: "Grease Filter Life", field: "maxGreasefilterTimer" },
        // { name:'maxCharcoalfilterTimer', title: "Charcoal Filter Life", field: "maxCharcoalfilterTimer" },
        { name:'steamClean', title: "Steam Clean", field: "steamClean" },
        { name:'airQuality', title: "Air Quality", field: "airQuality" },
        // { name:'charcoalFilterVideoURL', title: "Charcoal Filter Video URL", field: "CharcoalFilterVideoURL" },
        // { name:'charcoalFilterWebstoreURL', title: "Charcoal Filter Webstore URL", field: "CharcoalFilterWebstoreURL" },
        { name:'greaseFilterVideoURL', title: "Grease Filter Video URL", field: "GreaseFilterVideoURL" },
        // { name:'greaseFilterWebstoreURL', title: "Grease Filter Webstore URL", field: "GreaseFilterWebstoreURL" },
        { name:'hoodCleanVideoURL', title: "Hood Clean Video URL", field: "HoodCleanVideoURL" },
        { name:'laborWarranty', title: "Labor Warranty", field: "LaborWarranty" },
        { name:'partsWarranty', title: "Parts Warranty", field: "PartsWarranty" },
        { name:'productPhotoURL', title: "Product Photo URL", field: "ProductPhotoURL" },
        { name:'userManualURL', title: "User Manual URL", field: "UserManualURL" },
        { name:'enabled', title: "Enable", field: "Enabled" }
      ]
    },
    
    sessionKey: 'RangeHood.ModelListParams'
  }

  constructor(props) {
    super(props);

    // bind this props to function
    this.dataLoading = this.dataLoading.bind(this);
    viewRow = this.viewRow.bind(this);
    editRow = this.editRow.bind(this);
    deleteRow = this.deleteRow.bind(this);
    toggleSteamCleanRow = this.toggleSteamCleanRow.bind(this);
    toggleAirQualityRow = this.toggleAirQualityRow.bind(this);
    toggleEnableRow = this.toggleEnableRow.bind(this);

    // this component use props
    this.ref = null;
    this.rowClickType = null;
  };  

  /**
   *  reactFormatter bug, GroupBtnsMenu -> need before than reactFormatter
   *  
   ***/
  columns = [
    { title: "Model Number", field: "modelName" },
    { title: "Max. Fan Speed", field: "maxFanSpeed" },
    { title: "Max. Lighting Level", field: "maxLightLevel" },
    // { title: "Grease Filter Life", field: "maxGreasefilterTimer", formatter: reactFormatter(<GreaseHrsFormatColumn />) },
    // { title: "Charcoal Filter Life", field: "maxCharcoalfilterTimer", formatter: reactFormatter(<CharcoalHrsFormatColumn />) },
    { 
      title: "Steam Clean", 
      field: "steamClean",
      formatter: reactFormatter(<SteamCleanColumn />),
      width: 200
    },
    { 
      title: "Air Quality", 
      field: "airQuality",
      formatter: reactFormatter(<AirQualityColumn />),
      width: 200
    },
    // { title: "Charcoal Filter Video URL", field: "CharcoalFilterVideoURL", visible: false },
    // { title: "Charcoal Filter Webstore URL", field: "CharcoalFilterWebstoreURL", visible: false },
    { title: "Grease Filter Video URL", field: "GreaseFilterVideoURL", visible: false },
    // { title: "Grease Filter Webstore URL", field: "GreaseFilterWebstoreURL", visible: false },
    { title: "Hood Clean Video URL", field: "HoodCleanVideoURL", visible: false },
    { title: "Labor Warranty", field: "LaborWarranty", visible: false },
    { title: "Parts Warranty", field: "PartsWarranty", visible: false },
    { title: "Product Photo URL", field: "ProductPhotoURL", visible: false },
    { title: "User Manual URL", field: "UserManualURL", visible: false },
    { 
      title: "Enable", 
      field: "Enabled",
      formatter: reactFormatter(<EnableColumn />),
      width: 200
    },
    { title: "", field: "buttonGroup", minWidth: 180, headerSort:false, formatter: reactFormatter(<GroupBtnsMenu />),
      titleFormatter: groupMenuTitleFormatter, titleFormatterParams:{tableId : 'modelList'}}
  ];

  dataLoading = (datas) => {
    // const { status, reloadPageNumber } = this.props;
    if (this.ref && !this.state.isInitComplete) {
      // if not init and ref has data      
      // step1. init go to page button and change pagination button
      this.refListCommonFooter.initCommonListFooter();

      // step2. init page max label
      const table = this.ref.table;
      updateMaxPageNumber(table);

      // step3. init page buttons
      this.refListCommonFooter.overwritePageBtns();

      // step4. pagination init complete, save into state
      this.setState({
        isInitComplete:true,
        refTable:this.ref.table
      });

      // step5. if has reload table form session, reload it
      const { sessionKey } = this.state;
      const keepTableInfo = getTableInfoFromSession(sessionKey);
      if (keepTableInfo) {
        setTimeout(() => {
          reloadTable(table, keepTableInfo, this.refFilterSearch);
        }, 50);
      }
    }
  }

  doChecked = (cell, enable, eventFunction) => {
    if (cell.getElement) {
      let elFormatterCellCheck = cell.getElement().getElementsByClassName('formatterCell');    
      if (elFormatterCellCheck.length > 0) {
        let appendEl = elFormatterCellCheck[0].cloneNode(true);
        let targetClass, replaceClass, value;
        if (enable) {
          targetClass = 'icon-btn-checkbox-n';
          replaceClass = 'icon-btn-checkbox-p';
          value = 1;
        } else {
          targetClass = 'icon-btn-checkbox-p';
          replaceClass = 'icon-btn-checkbox-n';
          value = 0;
        }
        let elTargetCheck = appendEl.getElementsByClassName(targetClass);
        if (elTargetCheck.length > 0) {
          let elTarget = elTargetCheck[0];
          elTarget.className = replaceClass;
          elTarget.addEventListener('click', () => eventFunction(cell, enable));
          cell.setValue(value);
          // let elFormatterCell = elFormatterCellCheck[0];
          // elFormatterCell.appendChild(appendEl.firstElementChild);  // because it only has one child, so append first child
        }
      }
    } else {
      console.warn('error in doCheck cell element', cell);
    }
  }

  toggleEnableRow = (cell, enable) => {
    const { idToken, enableModal } = this.props;

    const doEnable = !enable;
    const row = cell.getRow();
    const data = row.getData();
    
    if (doEnable) {
      this.rowClickType = 'ENABLE';
    } else {
      this.rowClickType = 'DISABLE';
    }

    enableModal(idToken, data.modelName, doEnable);
    this.doChecked(cell, doEnable, toggleEnableRow);
  }

  toggleSteamCleanRow = (cell, enable) => {
    const { idToken, toggleSteamClean } = this.props;

    const doEnable = !enable;
    const row = cell.getRow();
    const data = row.getData();
    
    if (doEnable) {
      this.rowClickType = 'CHECK';
    } else {
      this.rowClickType = 'UNCHECK';
    }

    toggleSteamClean(idToken, data.modelName, doEnable);
    this.doChecked(cell, doEnable, toggleSteamCleanRow);
  }

  toggleAirQualityRow = (cell, enable) => {
    const { idToken, toggleAirQuality } = this.props;

    const doEnable = !enable;
    const row = cell.getRow();
    const data = row.getData();
    
    if (doEnable) {
      this.rowClickType = 'CHECK';
    } else {
      this.rowClickType = 'UNCHECK';
    }

    toggleAirQuality(idToken, data.modelName, doEnable);
    this.doChecked(cell, doEnable, toggleAirQualityRow);
  }

  reloadList = (e) => {
    const { idToken, initModelsData, forwardModelList } = this.props;
    if (idToken) {
      forwardModelList();
      initModelsData(idToken, null);
    }
  }

  viewRow = (props) => {
    this.rowClickType = 'VIEW';
    const { idToken, getModelDetail, history } = this.props;
    const { sessionKey, refTable } = this.state;

    if (history) {
      const row = props.cell.getRow();
      const data = row.getData();
      keepTableInfoToSession(sessionKey, refTable, this.refFilterSearch);
      getModelDetail(idToken, data.modelName);
      history.push("/HoodModeList/viewModel");
    }
  }

  addRow = () => {
    this.rowClickType = 'ADD';
    const { forwarModelDetail, history } = this.props;
    const { sessionKey, refTable } = this.state;

    // to reset password page
    if (history) {
      keepTableInfoToSession(sessionKey, refTable, this.refFilterSearch);
      forwarModelDetail();
      history.push("/HoodModeList/addModel");
    }
  }

  editRow = (props) => {
    this.rowClickType = 'EDIT';
    const { idToken, getModelDetail, history } = this.props;
    const { sessionKey, refTable } = this.state;

    if (history) {
      const row = props.cell.getRow();
      const data = row.getData();
      keepTableInfoToSession(sessionKey, refTable, this.refFilterSearch);
      getModelDetail(idToken, data.modelName);
      history.push("/HoodModeList/editModel");
    }
  }

  deleteRow = (props) => {
    this.rowClickType = 'DELETE';
    const { idToken, removeModel, models } = this.props;
    const { sessionKey, refTable } = this.state;    

    let check = window.confirm("Really to remove the model?");
    if (check) {
      const row = props.cell.getRow();
      const data = row.getData();
      keepTableInfoToSession(sessionKey, refTable, this.refFilterSearch);
      // do remove
      removeModel(idToken, data.modelName, models);
    }
  }

  doReloadTable = (msg) => {
    // reload table
    const { refTable, sessionKey } = this.state;
    const keepTableInfo = getTableInfoFromSession(sessionKey);
    if (keepTableInfo) {
      setTimeout(() => {
        reloadTable(refTable, keepTableInfo, this.refFilterSearch);
        if (msg) {
          alert(msg);
        }        
      }, 50);
    }
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    const { status, errMsg, menuMode } = this.props;
    if (prevProps.status !== status) {
        if (status === DELETE_MODEL_SUCCESS) {
          // reload table
          this.doReloadTable('Remove the model success.');
        } else if (status === DELETE_MODEL_FAIL) {
          if (errMsg) {
            // reload table
            this.doReloadTable(errMsg);
          }
      }
    } else if (prevProps.menuMode !== menuMode) {
      // if menu chagne size(mode), need redraw table
      const { refTable } = this.state;
      if (refTable) {
        refTable.redraw(true);
      }      
    }
  }

  render() {
    const paginationSize = this.refListCommonFooter ? this.refListCommonFooter.getPaginationSize() : 50;
    const options = {
      movableRows: false,
      pagination: 'local',
      paginationSize: paginationSize
    };
    const { models, popLoading } = this.props;
    const date = new Date();
    const timestamp = moment(date).format('YYYYMMDD');
    const excelFileName = 'Model List ' + timestamp;

    return (
      <div>
        <CommonListFooter tableId={this.tableId} refTable={this.state.refTable} refs={(ref) => {this.refListCommonFooter = ref;}} displayPaginationSize={paginationSize}></CommonListFooter>
        <div className='filter-bar'>
          <Row>
            <div className='area-list-title'>
              <div className='list-title'>Hood Model</div>
            </div>
            <div className='area-filter'>
              <FilterSearch filterId='modelListFilter' refTable={this.state.refTable} refColumns={this.state.filterColumns} quickSearchFilter={this.state.quickSearchFilter} 
                placeholder='Enter model name...' refs={(ref) => {this.refFilterSearch = ref;}} noAllOption={true}></FilterSearch>
            </div>
            <div className='area-table-tool-bar'>
              <ListSettingBtn tableId={this.tableId} refTable={this.state.refTable} refs={(ref) => {this.refTableToolBar = ref;}}
                visibleColumnsConfig={this.state.visibleColumnsConfig} defaultColumns={this.columns}>
              </ListSettingBtn>
            </div>
            <div className='area-list-btns' title='Export excel'>
              <span className='area-icon-btn-excel'>
                <ExcelFile filename={ excelFileName } element={<span className='icon-btn-export-excel'/>}>
                    <ExcelSheet data={ models } name="Models">
                        <ExcelColumn label="Model Number" value="modelName"/>
                        <ExcelColumn label="Max. Fan Speed" value={(col) => col.maxFanSpeed ? col.maxFanSpeed + " " : ""}/>
                        <ExcelColumn label="Max. Lighting Level" value={(col) => col.maxLightLevel ? col.maxLightLevel + " " : ""}/>
                        {/* <ExcelColumn label="Grease Filter Life" value={(col) => col.maxGreasefilterTimer ? col.maxGreasefilterTimer + " hr(s)" : ""}/>
                        <ExcelColumn label="Charcoal Filter Life" value={(col) => col.maxCharcoalfilterTimer ? col.maxCharcoalfilterTimer + " hr(s)" : ""}/> */}
                        <ExcelColumn label="Steam Clean" value={(col) => col.steamClean ? "Yes" : "No"}/>
                        <ExcelColumn label="Air Quality" value={(col) => col.airQuality ? "Yes" : "No"}/>
                        {/* <ExcelColumn label="Charcoal Filter Video URL" value="CharcoalFilterVideoURL"/>
                        <ExcelColumn label="Charcoal Filter Webstore URL" value="CharcoalFilterWebstoreURL"/> */}
                        <ExcelColumn label="Grease Filter Video URL" value="GreaseFilterVideoURL"/>
                        {/* <ExcelColumn label="Grease Filter Webstore URL" value="GreaseFilterWebstoreURL"/> */}
                        <ExcelColumn label="Hood Clean Video URL" value="HoodCleanVideoURL"/>
                        <ExcelColumn label="Labor Warranty" value={(col) => col.LaborWarranty ? col.LaborWarranty + " " : ""}/>
                        <ExcelColumn label="Parts Warranty" value={(col) => col.PartsWarranty ? col.PartsWarranty + " " : ""}/>
                        <ExcelColumn label="Product Photo URL" value="ProductPhotoURL"/>
                        <ExcelColumn label="User Manual URL" value="UserManualURL"/>
                        <ExcelColumn label="Enable" value={(col) => col.Enabled ? "Yes" : "No"}/>
                    </ExcelSheet>
                </ExcelFile>
              </span>
              <span className='area-icon-btn-add' title='Add new data'><span className='icon-btn-add' onClick={() => this.addRow()} /></span>
              <span className='area-icon-btn-reload' title='Reload list'><span className='icon-btn-reload' onClick={() => this.reloadList()} /></span>
            </div>
          </Row>
        </div>
        <div className='custom-list-table-area'>
          <ReactTabulator
            ref={ref => (this.ref = ref)}
            columns={this.columns}
            data={models}
            options={options}
            data-custom-attr="test-custom-attribute"
            className="custom-list-table"
            footerElement={commonListFooter}
            dataLoading={this.dataLoading}
            renderComplete={this.changePageNumber}
          />
        </div>
        <Loading loading={popLoading} center={true}></Loading>
      </div>
    )
  };
}

const mapStateToProps = (state, ownProps) => {
  return {
    idToken: state.logindReducers.idToken,
    status: state.maintenanceReducers.status,
    models: state.maintenanceReducers.models,
    popLoading: state.maintenanceReducers.popLoading,
    errMsg: state.maintenanceReducers.errMsg,
    menuMode: state.menuReducers.displayMode
  }
}

export default withRouter(connect(
  mapStateToProps, 
  { enableModal, toggleSteamClean, toggleAirQuality, forwarModelDetail, getModelDetail, removeModel, forwardModelList, initModelsData }
)(ModelList))
